import { useSelector } from 'react-redux';
import { Step } from 'signup-constants/Step';
import { Data } from 'signup-constants/signupData/Data';
import { getClickedToSeeAll, getPredictedTypeaheadValues } from '../../store/typeahead/selectors';
import { OptionalFormattedMessage } from '../../views-components/OptionalFormattedMessage';
import { StyledH3 } from './ACQ0143TitleContainer';
import { STEPS_WITH_PREFILLABLE_CONTENT, usePrefilledContent } from './usePrefilledContent';
import { useName } from '../../hooks/useName';
import { jsx as _jsx } from "react/jsx-runtime";
export const ACQ0143Title = ({
  stepTitle,
  isStepDataPrefilled,
  stepKey
}) => {
  const {
    prefilledTitle,
    shouldShowPrefilledTitle
  } = usePrefilledContent(isStepDataPrefilled);
  const hasClickedToSeeAllIndustries = useSelector(state => getClickedToSeeAll(state, Data.Industry));
  const predictedIndustries = useSelector(state => getPredictedTypeaheadValues(state, Data.Industry)) || [];
  const {
    canRenderNameSubtitle,
    name
  } = useName();
  const getTitleMessage = () => {
    if (stepKey === Step.Industry) {
      if (!hasClickedToSeeAllIndustries && predictedIndustries.length === 1) {
        return prefilledTitle;
      }
      return stepTitle;
    }
    return stepKey && STEPS_WITH_PREFILLABLE_CONTENT.includes(stepKey) && shouldShowPrefilledTitle ? prefilledTitle : stepTitle;
  };
  const getTitleMessageComponent = () => {
    if (stepKey === Step.UseCase) {
      return canRenderNameSubtitle ? /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: `views.${stepKey}.title.welcome_title`,
        options: {
          name
        }
      }) : /*#__PURE__*/_jsx(OptionalFormattedMessage, {
        message: `views.${stepKey}.title.welcome_title_no_name`
      });
    }
    return /*#__PURE__*/_jsx(OptionalFormattedMessage, {
      message: getTitleMessage()
    });
  };
  return /*#__PURE__*/_jsx(StyledH3, {
    children: getTitleMessageComponent()
  });
};